import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck } from "lucide-react";
import { adminClient, notifyProductsChanged } from "./api";
import { fetchShipping } from "@/hooks/useShipping";

export default function ShippingCard() {
  const [form, setForm] = useState({ fee: "", free_over: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminClient.get("/admin/shipping").then(({ data }) => setForm({ fee: data.fee, free_over: data.free_over })).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await adminClient.put("/admin/shipping", { fee: parseFloat(form.fee) || 0, free_over: parseFloat(form.free_over) || 0 });
      setForm({ fee: data.fee, free_over: data.free_over });
      fetchShipping(true);
      notifyProductsChanged();
      toast.success(`Shipping updated · $${Number(data.fee).toFixed(2)}, free over $${Number(data.free_over).toFixed(0)} — live on every listing`);
    } catch (err) { toast.error(err?.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <Card className="p-5 border-2 border-zinc-200 max-w-xl" data-testid="shipping-card">
      <div className="flex items-center gap-2 mb-1">
        <Truck className="w-4 h-4 text-[#0C2E2B]" />
        <h3 className="font-display font-black text-[#0C2E2B]">Merch shipping</h3>
      </div>
      <p className="text-xs text-zinc-500 mb-4">Shown on every product card, the detail view and the cart. Orders use whatever is saved here — no redeploy needed.</p>
      <form onSubmit={save} className="grid grid-cols-2 gap-3 items-end">
        <div>
          <Label className="text-xs font-bold uppercase tracking-widest text-zinc-700">Flat shipping fee ($)</Label>
          <Input data-testid="shipping-fee-input" type="number" step="0.01" min="0" value={form.fee} onChange={(e) => setForm({ ...form, fee: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label className="text-xs font-bold uppercase tracking-widest text-zinc-700">Free shipping over ($)</Label>
          <Input data-testid="shipping-free-over-input" type="number" step="1" min="0" value={form.free_over} onChange={(e) => setForm({ ...form, free_over: e.target.value })} className="mt-1" />
        </div>
        <Button data-testid="shipping-save-btn" type="submit" disabled={saving} className="btn-kinetic rounded-md col-span-2">{saving ? "Saving…" : "Save shipping"}</Button>
      </form>
      <p className="text-[10px] text-zinc-400 mt-3" data-testid="shipping-preview">Customers will see: "+ ${Number(form.fee || 0).toFixed(2)} shipping · free over ${Number(form.free_over || 0).toFixed(0)}"</p>
    </Card>
  );
}
